import MwButton from './src/button';

MwButton.install = function(Vue) {
  Vue.component(MwButton.name, MwButton);
};
export default MwButton;



// WEBPACK FOOTER //
// ./src/common/components/packages/button/index.js